import Vue from 'vue'
import App from './App.vue'
import router from './router'
import config from './config'
import api from './api'
import store from './store'
import {
  Form,
  Field,
  Button,
  Picker,
  Dialog,
  Swipe,
  SwipeItem,
  Loading,
  Icon,
  Tabs,
  Tab,
  List,
  Uploader,
  Overlay,
  Toast
} from 'vant'
import xesAlert from '@/common/plugins/XesAlert'
import validator from 'validator'
import { XesCookie } from '@xes/terra-utils'
import logInfo from './config/log.json'
// import '@/common/utils/main' // 引入通用入口文件
import { initLogSDKNew } from '@/common/utils/main-logadmin' // 引入通用入口文件
Vue.use(xesAlert)
Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Picker)
  .use(Dialog)
  .use(Swipe)
  .use(SwipeItem)
  .use(Loading)
  .use(Icon)
  .use(Tabs)
  .use(Tab)
  .use(List)
  .use(Uploader)
  .use(Overlay)
  .use(Toast)
// 全局配置信息
Vue.prototype.$api = api
Vue.prototype.$config = config
Vue.prototype.$validator = validator
Vue.prototype.$xesCookie = XesCookie
initLogSDKNew(logInfo.logId)
Vue.prototype.$xesLogger.setCommonParam({
  sGroupId: config.sGroupId
})
// 日志打点相关
// Vue.prototype.$xesLogger.opts.common.eventid = config.eventid
// Vue.prototype.$xesLogger.opts.param.sGroupId = config.sGroupId

// 配置微信分享
window.onload = () => {
  if (window._xesShare.shareClient === 1 && config.xesShare.title) {
    window._xesShare.shareLink(config.xesShare)
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
